import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import SearchPanel from "@widgets/SearchPanel";
import {
  fnPrintByReport,
  getInitForm,
  getTablebySql,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import FreeForm from "@widgets/FreeForm";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { showPopupModal } from "@widgets/CommonModal";
import SnButton from "@shared/components/SnButton";
import { dateToString } from "@shared/utils/DateUtils";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_MTL_BAS_REG_007 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const { userInfo } = global(); // Login user 정보
  const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const gridApiRef2 = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const SharedFormref1 = useRef<any>();

  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;

  //#region  Components useState
  const [sharedForm, setSharedForm] = useState<any[]>([]);

  const [columns1, setColums1] = useState<any[]>([]); // gridApiRef1 컬럼 설정 관련
  const [columns2, setColums2] = useState<any[]>([]); // gridApiRef2 컬럼 설정 관련

  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRef1 datasource 관련
  const [dataSource2, setDataSource2] = useState<any>(); // gridApiRef2 datasource 관련
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [freeFormData, setFreeFormData] = useState<any>();
  const [gridFocus1, setGridFocus1] = useState(false);
  const [gridFocus2, setGridFocus2] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);
  let addedarow = false;

  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_MTL_BAS_REG_007";
  const defaultSize = {
    panel2: "89.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      setDataSource2([]);
      try {
        const rtn: any = await getInitForm();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums1(rtn.grid.grid1);
        setSharedForm(rtn.form.freeform1);
        const today = new Date();
        const sqlQuery = {
          sql: "SELECT f.*,to_char(CAST(:week AS TIMESTAMP), 'IW') as week FROM fn_sys_date_week_conv(concat(:yyyy, to_char(CAST(:week AS TIMESTAMP), 'IW')),NULL ) f;",
          week: dateToString(new Date()),
          yyyy: today.getFullYear(),
        };
        const Data = await getTablebySql(sqlQuery);
        const freeformData = {
          cd_item: "",
          cd_firm: userInfo.cd_firm,
          cd_item_cust: "",
          nm_item: "",
          no_barcode: "",
          qt: 0,
          dc_item_unit: "",
          dt_io: dateToString(new Date()),
          dt_bsn: dateToString(new Date()),
          dt_make: dateToString(new Date()),
          dt_from: Data[0].dt_start,
          dt_to: Data[0].dt_end,
          fg_search: Data[0].week,
          str_search: today.getFullYear(),
          serialStart: "",
          serialEnd: "",
          cd_cust_rcv: "",
          nm_cust: "",
          nm_cust_rcv: "",
          cd_cust: "",
        };
        setFreeFormData(freeformData);
      } catch (error) {}
    };
    fetchform();
  }, []);
  useEffect(() => {
    gridApiRef1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);
  useImperativeHandle(ref, () => ({
    onSearch,
    onDelete,
    onSave,
    onPrint,
  }));

  //region OnSearch
  const onSearch = async () => {
    try {
      const param = {
        id: "sn_mtl_bas_reg_007_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(param);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        setGridFocus(true);
      }
    } catch (error) {}
  };
  //region onInsert

  //region onDelete
  const onDelete = async () => {
    if (gridApiRef1.current?.api.getDisplayedRowCount() === 0) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제 하시겠습니까?");

    if (!confirm) {
      return;
    }

    gridApiRef1.current?.deleteSelectedRows();

    setTimeout(() => {
      const rowCount = gridApiRef1.current?.api?.getDisplayedRowCount?.() || 0;
      if (rowCount > 0) {
        const selectedRow =
          gridApiRef1.current.api.getDisplayedRowAtIndex(0)?.data;
        //setFocusedRowData(selectedRow);
      } else {
        //setFocusedRowData(undefined);
      }
    }, 100);

    const realDeletedRows = gridApiRef1.current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridApiRef1.current.resetUpdate();
      return;
    }
    return await onSave();
  };
  const onPrint = async () => {
    gridApiRef1.current?.api.stopEditing();
    const nmArray: string[] = [];
    const itemArray: string[] = [];
    const qtArray: string[] = [];
    const dcitemspecArray: string[] = [];
    const dtioArray: string[] = [];
    const nmCustArray: string[] = [];
    const nobarcodeArray: string[] = [];
    const checkedRows = gridApiRef1.current.getCheckedRows();
    for (const object of checkedRows) {
      const sqlQuery = {
        sql: `update mas_bsn_list set qt_print = qt_print + 1 , yn_print = 'Y' 
              where cd_firm = :cd_firm and cd_item = :cd_item and no_barcode = :no_barcode and cd_bsn = 'MTL' `,
        cd_firm: userInfo.cd_firm,
        cd_item: object.cd_item,
        no_barcode: object.no_barcode,
      };
      await getTablebySql(sqlQuery);
      nmArray.push(object.nm_item);
      itemArray.push(object.cd_item);
      qtArray.push(object.qt);
      dcitemspecArray.push(object.dc_item_spec);
      dtioArray.push(object.dt_io);
      nmCustArray.push(object.nm_cust);
      nobarcodeArray.push(object.no_barcode);
    }

    const nm = nmArray.join(",");
    const item = itemArray.join(",");
    const qt = qtArray.join(",");
    const dcitemspec = dcitemspecArray.join(",");
    const dtio = dtioArray.join(",");
    const nmcust = nmCustArray.join(",");
    const nobarcode = nobarcodeArray.join(",");
    gridApiRef1.current.resetUpdate();
    // 결과 객체 반환
    return {
      cd_firm: userInfo.cd_firm,
      nm_item: nm,
      cd_item: item,
      qt: qt,
      dc_item_spec: dcitemspec,
      dt_io: dtio,
      nm_cust: nmcust,
      no_barcode: nobarcode,
    };
  };
  //region onAddRow
  const onAddRow = async () => {
    try {
      const formData = SharedFormref1.current.getFormdata();
      const no_docu = searchRef.current.getFormdata().no_docu;
      let remaining = formData.qt;
      const sqlQuery = {
        sql: "select * from sp_mas_bsn_list_get(:cd_firm,'MTL',:cd_item,:cd_item_cust,:dt_bsn,:qt_lotsize,:qt,'Y','');",
        cd_firm: userInfo.cd_firm,
        cd_item: formData.cd_item,
        cd_item_cust: formData.cd_item_cust,
        dt_bsn: formData.dt_bsn,
        qt_lotsize: formData.qt_lotsize,
        qt: formData.qt,
      };
      const Data = await getTablebySql(sqlQuery);
      let index = 0;
      while (remaining > 0) {
        const min = Math.min(remaining, formData.qt_lotsize);
        const newRow = {
          cd_firm: userInfo.cd_firm,
          cd_item: formData.cd_item,
          cd_item_cust: formData.cd_item_cust,
          nm_item: formData.nm_item,
          qt_print: 0,
          qt: min,
          ym: formData.dt_bsn,
          dc_item_spec: formData.dc_item_spec,
          dc_item_unit: formData.dc_item_unit,
          dt_io: formData.dt_io,
          dt_bsn: formData.dt_bsn,
          dt_make: formData.dt_make,
          no_barcode: Data[index++].no_bsn,
          no_docu: no_docu,
          cd_bsn: "MTL",
          yn_print: "N",
        };
        remaining -= min;
        gridApiRef1.current?.addRow(newRow);
        const api = gridApiRef1.current.api;
        const rowCount = api.getDisplayedRowCount();
        const lastRowIndex = rowCount - 1;
        const lastRowNode = api.getDisplayedRowAtIndex(lastRowIndex);
        if (lastRowNode) {
          lastRowNode.setDataValue("fixCheckbox", true); // 체크박스 자동 체크
        }
      }
      onSave();
    } catch (error: any) {}
  };
  //region onDeleteRow
  const onDeleteRow = async () => {
    gridApiRef2.current?.deleteSelectedRows();
  };

  const onClearList = () => {
    gridApiRef1.current?.api?.stopEditing?.();
    gridApiRef1.current?.resetUpdate?.();
    setDataSource1([]);
    setGridFocus(false);
  };

  //region OnSave
  const onSave = async () => {
    try {
      gridApiRef1.current.api.stopEditing();

      const requiredValuesCheckH = gridApiRef1.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }

      const masBsnListChanges = gridApiRef1.current.getChange();

      const SaveData = {
        mas_bsn_list: masBsnListChanges,
      };

      await fnSave("SN_MTL_BAS_REG_007_SAVE_01", SaveData);

      gridApiRef1.current.resetUpdate();
    } catch (error: any) {}
  };

  //region BTNclick
  const onFormBtnClick = async (id: string) => {
    if (id === "btn_save") {
      onAddRow();
    }
    if (id === "btn_list_clear" || id === "btn_clear_list") {
      onClearList();
    }
    if (id === "btn_print") {
      const printParams = await onPrint();
      if (!printParams) return;
      await fnPrintByReport("rpt_mtl_bas_reg_007_chem_02", printParams);
    }
  };
  const onValueChanged = async (data: any, param: string, formData: any) => {
    const sharedformData = SharedFormref1.current.getFormdata();
    switch (param) {
      case "qt":
        const sqlQuery = {
          sql: "select * from sp_mas_bsn_get(:cd_firm,'MTL',:cd_item,:cd_item_cust,:dt_bsn,1,1,'N','');",
          cd_firm: userInfo.cd_firm,
          cd_item: sharedformData.cd_item,
          cd_item_cust: sharedformData.cd_item_cust,
          dt_bsn: sharedformData.dt_bsn,
        };
        const Data = await getTablebySql(sqlQuery);
        return {
          serialStart: Data[0].no_serial,
          serialEnd:
            Data[0].no_serial + Math.ceil(data / sharedformData.qt_lotsize) - 1,
        };
      case "cd_cust": {
        return {
          cd_cust_rcv: data.cd_cust ?? "",
          nm_cust: data.nm_cust ?? "",
        };
      }
      case "cd_item":
        const cd_firm = userInfo.cd_firm;
        const cd_item = data.cd_item;
        const sql = ` SELECT cd_item as code, cd_Item as name FROM mas_item WHERE cd_firm = '${cd_firm}' AND cd_item = '${cd_item}'
                      UNION ALL
                      SELECT cd_item_cust as code, cd_item_cust as name FROM MAS_CUSTITEM WHERE cd_firm = '${cd_firm}' AND cd_item = '${cd_item}';`;
        const update = sharedForm.map((row: any) =>
          row.cd_param === "cd_item_cust" ? { ...row, dc_sql: sql } : row
        );

        setSharedForm(update);
        return {
          cd_item_cust: data.cd_item,
          nm_item: data.nm_item,
          dc_item_spec: data.dc_item_spec,
          dc_item_unit: data.dc_item_unit,
          qt_lotsize: data.qt_lotsize,
        };
      case "cust_barcode":
        const sqlQuery2 = {
          sql: "select * from fn_mtl_barcode_split(:cd_firm,:dc_barcode);",
          cd_firm: userInfo.cd_firm,
          dc_barcode: data,
        };
        const Data2 = await getTablebySql(sqlQuery2);
        const cd_firm2 = userInfo.cd_firm;
        const cd_item2 = Data2[0].cd_item;
        const sql2 = ` SELECT cd_item as code, cd_item as name FROM mas_item WHERE cd_firm = '${cd_firm2}' AND cd_item = '${cd_item2}'
                      UNION ALL
                      SELECT cd_item_cust as code, cd_item_cust as name FROM MAS_CUSTITEM WHERE cd_firm = '${cd_firm2}' AND cd_item = '${cd_item2}';`;
        const update2 = sharedForm.map((row: any) =>
          row.cd_param === "cd_item_cust" ? { ...row, dc_sql: sql2 } : row
        );

        setSharedForm(update2);
        return {
          cd_item: Data2[0].cd_item,
          cd_item_cust: Data2[0].cd_item_cust,
          qt_lotsize: Data2[0].qt_lotsize,
          qt: Data2[0].qt,
        };
      case "dc_loc":
        let cd_cust = "";
        if (sharedformData.cd_cust !== null && sharedformData.cd_cust !== "")
          cd_cust = sharedformData.cd_cust;

        const sqlQuery6 = {
          sql: "select * from mas_item where cd_firm = :cd_firm and dc_loc = :dc_loc and (:cd_cust_rcv is null or :cd_cust_rcv = '' or cd_cust_rcv = :cd_cust_rcv) limit 1;",
          cd_firm: userInfo.cd_firm,
          dc_loc: data,
          cd_cust_rcv: cd_cust,
        };
        const Data6 = await getTablebySql(sqlQuery6);
        if (Data6.length === 0) {
          return;
        }
        return {
          cd_item: Data6[0].cd_item,
          cd_item_cust: Data6[0].cd_item_cust,
          qt_lotsize: Data6[0].qt_lotsize,
        };
      case "fg_search":
        const sqlQuery3 = {
          sql: "SELECT f.* FROM fn_sys_date_week_conv(concat(:yyyy, :week),NULL ) f;",
          week: data,
          yyyy: sharedformData.str_search,
        };
        const Data3 = await getTablebySql(sqlQuery3);
        return {
          dt_from: Data3[0].dt_start,
          dt_to: Data3[0].dt_end,
        };
      case "str_search":
        const sqlQuery4 = {
          sql: "SELECT f.* FROM fn_sys_date_week_conv(concat(:yyyy, :week),NULL ) f;",
          week: sharedformData.fg_search,
          yyyy: data,
        };
        const Data4 = await getTablebySql(sqlQuery4);
        return {
          dt_from: Data4[0].dt_start,
          dt_to: Data4[0].dt_end,
        };
      //날짜변경시 이벤트가 안먹음
      case "dt_from":
      case "dt_to":
        const sqlQuery5 = {
          sql: "select *,to_char(CAST(:dt AS TIMESTAMP), 'IW') as week from fn_sys_date_week_conv(null,:dt)",
          dt: data,
        };
        const Data5 = await getTablebySql(sqlQuery5);
        return {
          dt_from: Data5[0].dt_start,
          dt_to: Data5[0].dt_end,
          fg_search: Data5[0].week,
          str_search: Data5[0].yyyyww.substring(0, 4),
        };
    }
  };

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <FreeForm
          ref={SharedFormref1}
          data={freeFormData}
          controls={sharedForm}
          onButtonClick={onFormBtnClick}
          onValueChanged={onValueChanged}
        ></FreeForm>
        <div className="flex justify-end">
          <SnButton text="리스트초기화" onClick={onClearList} />
        </div>
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={500}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            ref={gridApiRef1}
            columnConfig={columns1}
            rowData={dataSource1}
            isEditable={false} // 수정 가능여부
            ischeckboxSelection={true}
            rowSelection="multiple" // 로우 선택 모드 (단일)
          />
        </SnResizable>
      </div>
    </div>
  );
  //#endregion
});
export default SN_MTL_BAS_REG_007;
